import React from 'react';
import { useNavigate } from 'react-router-dom';
import { LeadRowChips } from '../inbox/chips';
import { needsYouReason, formatRowTime, getSortTime } from '../../utils/todayStats';

export default function NeedsYouQueue({ items }) {
  const navigate = useNavigate();
  const count = items.length;

  function openLead(conv) {
    const path = conv.formId
      ? `/leads/${conv.formId}?conversation=${conv.id}`
      : `/leads?conversation=${conv.id}`;
    navigate(path);
  }

  return (
    <div className="today-panel">
      <div className="today-panel-header">
        <span className="today-panel-title">Needs you</span>
        {count > 0 && (
          <span className="today-badge-warn">{count} WAITING</span>
        )}
      </div>
      <div className="today-panel-body">
        {count === 0 ? (
          <div className="today-empty">Nothing needs you right now.</div>
        ) : (
          items.map((conv) => (
            <div key={conv.id} className="today-queue-row">
              <div className="today-queue-row-top">
                <div className="today-queue-title">{conv.leadName || conv.leadEmail}</div>
                <span className="today-queue-time">{formatRowTime(getSortTime(conv))}</span>
              </div>
              <div className="today-queue-subtext">{needsYouReason(conv)}</div>
              <LeadRowChips lead={conv} />
              <div style={{ marginTop: '10px' }}>
                <button type="button" className="inbox-pill-btn-primary" onClick={() => openLead(conv)}>
                  Open thread
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}
